<script>
    import { Modal, ModalBody, ModalHeader, ModalFooter } from "sveltestrap";
    import Loading from "../../Loading.svelte";
    import alertify from "alertifyjs";
    import backend from "../../../../server";
    import { ICONS } from "../../../../js/icons"; // ← icono de copiar

    export let showFindIdByUsernameOrigin = false;
    export let usernameOrigin = "";

    let loading = false;
    let displayId = "";
    let lastQueried = "";

    // Busca automáticamente al abrir con username válido
    $: (async () => {
        if (showFindIdByUsernameOrigin && usernameOrigin && usernameOrigin !== lastQueried) {
            lastQueried = usernameOrigin;
            await find();
        }
    })();

    async function find() {
        const u = (usernameOrigin || "").trim();
        if (!u) {
            alertify.warning("No hay username para buscar.");
            return;
        }
        loading = true;
        displayId = "";
        try {
            const { data } = await backend.logs.resolveUserMessage({ username: u });
            const raw = data?.rawmessage || "";

            // Extraer Id desde el JSON dentro del raw (o por regex)
            let extractedId = "";
            const matchJson = raw.match(/\{[^}]*\}/);
            if (matchJson) {
                try {
                    const obj = JSON.parse(matchJson[0]);
                    extractedId = obj.Id || obj.id || "";
                } catch {
                    const mid = raw.match(/"Id"\s*:\s*"([^"]+)"/i);
                    extractedId = (mid && mid[1]) || "";
                }
            } else {
                const mid = raw.match(/"Id"\s*:\s*"([^"]+)"/i);
                extractedId = (mid && mid[1]) || "";
            }

            displayId = extractedId;
            if (!displayId) alertify.warning("Usuario no encontrado en el rango de 15 días.");
        } catch (e) {
            alertify.error("Error al consultar logs.");
        } finally {
            loading = false;
        }
    }

    function close() {
        showFindIdByUsernameOrigin = false;
        setTimeout(() => {
            lastQueried = "";
            displayId = "";
        }, 0);
    }

    async function copyId() {
        if (!displayId) return;
        try {
            await navigator.clipboard.writeText(displayId);
            alertify.success("ID copiado al portapapeles");
        } catch {
            alertify.error("No se pudo copiar");
        }
    }
</script>

<Modal isOpen={showFindIdByUsernameOrigin} toggle={close} size="lg" backdrop="static">
    <ModalHeader toggle={close}>
        Buscar ID por Username Origin
    </ModalHeader>

    <ModalBody>
        <Loading bind:loading />

        <div class="center-wrap">
            <div class="username">Usuario: <span class="mono">{usernameOrigin || "—"}</span></div>

            <div class="id-row">
                <div class="id-label">ID</div>
                <div class="id-value mono">{displayId || "—"}</div>
                <button class="btn btn-outline-secondary btn-sm copy-btn" on:click={copyId} disabled={!displayId} title="Copiar ID">
                    {@html ICONS.clipboard}
                    <span class="visually-hidden">Copiar</span>
                </button>
            </div>
        </div>
    </ModalBody>

    <ModalFooter>
        <button class="btn btn-outline-secondary" on:click={close}>Cerrar</button>
    </ModalFooter>
</Modal>

<style>
    .center-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: .75rem;
        padding: .25rem 0 .5rem;
    }

    .username {
        font-size: .95rem;
        color: #6b7280; /* gris sutil */
    }

    .mono {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    }

    .id-row {
        display: flex;
        align-items: center;
        gap: .5rem;
        justify-content: center;
        flex-wrap: wrap;
    }

    .id-label {
        font-weight: 600;
        letter-spacing: .02em;
        text-transform: uppercase;
        font-size: .8rem;
        color: #374151;
    }

    .id-value {
        font-size: 1.25rem;
        font-weight: 700;
    }

    .copy-btn :global(svg) {
        width: 16px;
        height: 16px;
        vertical-align: -2px;
    }

    .visually-hidden {
        position: absolute !important;
        height: 1px; width: 1px;
        overflow: hidden; clip: rect(1px, 1px, 1px, 1px);
        white-space: nowrap; border: 0; padding: 0; margin: -1px;
    }
</style>
